import { IScreenController } from "./screen-controller";
import { IScreenStatusCommand } from "./../screen-status-command";
import { INavigationStatus } from "../navigation-status";
import { NavigationBarManager } from "../navigation-bar-manager";
import { Constants } from "../constants";

/**
 * Generic controller for screens that doesn't have custom logic 
 * based on answers by the user
 **/
export class GenericScreenController implements IScreenController {

    public SCREEN_INDEX: number;

    public isActiveInTheFlow: boolean;

    /**
     * Defines the Jquery selector of the screen
     **/
    protected screenSelector: string;

    /**
     * Contains the current screen DOM element
     */
    protected screenDomElement: any;

    /**
     * List with the screens that should be displayed after this screen
     */
    protected nextSteps: Array<IScreenStatusCommand>;

    protected navigationStatus: INavigationStatus;

    protected navigationBarManager: NavigationBarManager;

    /**
     * Constructor
     * @param index Based 0 position of the screen in the flow and the array of screens.
     * @param nextSteps List of the next screens when the user click "Next" on the current screen.
     * @param isActiveInTheFlow Indicates if the screen is active or not in the flow by default.
     */
    constructor(index: number,
        navigationBarManager: NavigationBarManager,
        nextSteps: Array<IScreenStatusCommand> = [],
        isActiveInTheFlow: boolean = false,
        navigationStatus: INavigationStatus = {
            showCloseApp: false,
            showExit: false,
            showNext: true,
            showPrevious: true,
            showStartOver: false,
            progressBarGroupIndex: 0
        }) {
        this.SCREEN_INDEX = index;
        this.isActiveInTheFlow = isActiveInTheFlow;
        this.screenSelector = `.tobacco-cessation-form-screen[data-screen-index="${this.SCREEN_INDEX}"]`;
        this.screenDomElement = $(this.screenSelector);
        this.nextSteps = nextSteps;
        this.navigationStatus = navigationStatus;
        this.navigationBarManager = navigationBarManager;
    }

    public validateScreen(): boolean {
        return true;
    }

    public initEvents(): void {

    }

    public calculateNextScreensInFlow(): Array<IScreenStatusCommand> {
        return this.nextSteps;
    }

    public showScreen(): void {
        this.screenDomElement.show();
        this.enableNextButton();
        this.recordAnalyticsPageViewEvent();
    }

    public hideScreen(): void {
        this.screenDomElement.hide();
    }

    /**
     * Validates the given radiobutton question has an option selected
     * @param questionIndex Based 0 index position of the question in the form
     * @returns True if an option is selected, False if no option was selected
     */
    public validateRequiredRadiobuttonQuestion(questionIndex: number = 0): boolean {

        let questionContainer = $(this.screenDomElement.find(".FormChoice")[questionIndex]);
        let selectedOption = questionContainer.find(".FormChoice__Input.FormChoice__Input--Radio:checked").val();

        if (!selectedOption) {
            questionContainer.addClass("ValidationFail");
            let errorMessageContainer = questionContainer.find(".Form__Element__ValidationError");
            errorMessageContainer.html("This field is required");
            errorMessageContainer.show();

            return false;
        } else {
            questionContainer.removeClass("ValidationFail");
            let errorMessageContainer = questionContainer.find(".Form__Element__ValidationError");
            errorMessageContainer.html("");
            errorMessageContainer.hide();
            return true;
        }
    }

    public getNavigationBarStatus(): INavigationStatus {
        return this.navigationStatus;
    }

    public loadScreenInitialStatus(): void { }

    protected enableNextButton(newTitle: string = Constants.NEXT_TITLE) {
        this.navigationBarManager.updateNextButtonTitle(newTitle);
        this.navigationBarManager.enableNextButton();
        let nextSteps = this.calculateNextScreensInFlow();
        if (nextSteps.length > 0) {
            this.navigationBarManager.updateUpNextLable(nextSteps[0]);
        }
    }

    protected disableNextButton(newTitle: string = Constants.NEXT_TITLE) {
        this.navigationBarManager.updateNextButtonTitle(newTitle);
        this.navigationBarManager.disableNextButton();
    }

    /**
     * Sends PageView event to Google Analytics
     */
    protected recordAnalyticsPageViewEvent() {

        let screenTitleH2: any = this.screenDomElement.find("h2.Form__Title");

        let adminDiv = screenTitleH2.find("div");

        if (adminDiv.length > 0) {
            screenTitleH2 = adminDiv;
        }

        let online = 'no'
        if (navigator.onLine) {
            online = 'yes';
        }

        (<any>window).gtag('event', 'page_view', {
            'page_name': screenTitleH2.html(),
            'page_title': screenTitleH2.html(),
            'user_online': online,
            'user_id': (<any>window).userId
        });
    }

    public getScreenTitle() {
        return this.screenDomElement.find(".Form__Title").html();
    }
}